const fetchErrorCauses = {
  offline: 'offline',
  cors: 'cors',
  badUrl: 'bad-url',
  aborted: 'aborted',
  blocked: 'blocked',
  unknown: 'unknown'
};
const getFetchErrorCause = async (url, error) => {
  // Default to 'unknown' to avoid misclassifying causes we don't explicitly check for (possible cause could be CSP)
  let cause = fetchErrorCauses.unknown;
  if (!navigator.onLine) {
    cause = fetchErrorCauses.offline;
  } else if (error.name === 'AbortError') {
    cause = fetchErrorCauses.aborted;
  } else if (error instanceof TypeError) {
    // unreliable check. The entry may not yet be present in the performance timeline even for requests that did leave the browser.(it's populated asynchronously by the browser))
    const entries = performance.getEntriesByName(url, 'resource');
    if (entries.length === 0) {
      // Request never left the browser — blocked by extension or CSP
      cause = fetchErrorCauses.blocked;
    } else {
      // Attempt a no-cors probe to distinguish CORS from bad URL
      await fetch(url, {
        mode: 'no-cors'
      }).then(() => {
        cause = fetchErrorCauses.cors;
      }).catch(() => {
        cause = fetchErrorCauses.badUrl;
      });
    }
  }
  return cause;
};
export default getFetchErrorCause;